import type { OrganizerDashboardResponse } from '../types/database';

const API_BASE_URL = import.meta.env.VITE_API_URL || '';

class OrganizerDashboardService {
  async getDashboard(identifier: string): Promise<OrganizerDashboardResponse> {
    const url = `${API_BASE_URL}/api/groups/${identifier}/organizer-dashboard`;
    const response = await fetch(url, {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
    });

    if (!response.ok) {
      if (response.status === 404) {
        throw new Error('Grupo no encontrado');
      }
      throw new Error(`Error al cargar dashboard: ${response.status}`);
    }

    return await response.json();
  }
}

export const organizerDashboardService = new OrganizerDashboardService();
